import React from 'react';
import Icon from '../Icon/Icon';
import * as styles from './Checkbox.module.scss';

/**
 * Checkbox component.
 *
 * @param {Object} props - The props of the component.
 * @param {string} props.value - The value of the checkbox.
 * @param {string} props.label - The label text for the checkbox.
 * @param {string} props.id - The ID for the checkbox and its associated label.
 * @param {string} props.name - The name of the checkbox.
 * @param {Function} props.action - The callback to be called when the checkbox value changes.
 * @param {boolean} props.isChecked - Determines if the checkbox is checked.
 * @param {string} [props.className] - Additional classnames to be added to the wrapper.
 * @param {string} [props.variant] - The variant/style of the checkbox.
 * @returns {React.Element} - The rendered Checkbox component.
 */
const Checkbox = ({ value, label, id, name, action, isChecked, className = '', variant = '' }) => {
  return (
    <div className={`${styles.checkboxWrapper} ${className}`}>
      <div className={styles.inputWrapper}>
        <input
          type="checkbox"
          className={styles.input}
          id={id}
          value={value}
          name={name}
          data-label={label}
          onChange={e => action(e)}
          checked={isChecked}
        />
        <span className={`${styles.box} ${variant ? styles[variant] : ''}`} role="presentation">
          <Icon symbol="tick" />
        </span>
      </div>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
